export default __webpack_public_path__ + "static/media/bg-coupon-uncollected-point-blue.245e5ae5.png";